import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showSmall)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.linkCounter)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.sanitizeUrl(_ctx.articleUrl) + '#likes-and-comments',
              class: "comments-counter-link comments-counter-dark btn"
            }, [
              _cache[0] || (_cache[0] = _createElementVNode("i", {
                class: "fa-regular fa-comment",
                "aria-hidden": "true"
              }, null, -1)),
              _cache[1] || (_cache[1] = _createTextVNode()),
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.spanClass)
              }, _toDisplayString(_ctx.commentsCount), 3)
            ], 8, _hoisted_1))
          : _createCommentVNode("", true),
        (!_ctx.linkCounter)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass([_ctx.spanClass, "comments-counter-dark"])
            }, [
              _cache[2] || (_cache[2] = _createElementVNode("i", {
                class: "fa-regular fa-comment",
                "aria-hidden": "true"
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.commentsCount), 1)
            ], 2))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: _normalizeClass([_ctx.spanClass, "comments-counter-dark"])
      }, _toDisplayString(_ctx.commentsCount) + " " + _toDisplayString(_ctx.commentsString), 3))
}